<template>
<div class="limit">
	<button v-for="limitOpt in availableLimits"
			:disabled="value === limitOpt"
			:key="limitOpt"
			@click="$emit('input', limitOpt)">{{limitOpt}}
	</button>
</div>
</template>

<script>
export default {
	props: {
		value: Number
	},
	data() {
		return {
			availableLimits: [10, 20, 30]
		}
	}
}

</script>

<style lang="scss" scoped>
@import "../../styles/variables";
.limit {
	position: relative;
	display: flex;
	justify-content: space-between;
	width: 90px;
	background: transparent;
	border-radius: 4px;

	button {
		width: 26px;
		height: 30px;
		border-radius: 2px;
		background-color: #f2f4fb;
		border: none;
		color: #444;
		transition: width 300ms;
		cursor: pointer;
		box-shadow: 0px 5px 5px -1px rgba(0, 0, 0, 0.25);

		.dark & {
			background-color: $bg-grey;
			color: $dark-grey;

			&:disabled {
				color: $dark-grey;
			}
		}

		&:disabled {
			background-color: $alt-blue;
			color: white;
		}
	}
}
</style>
